export enum AiReservationType {
  Phone = 'Phone',
}
